import { rebuildFieldTypesConfig } from '@databases/core-event-bus/listeners';
import { rebuildFieldTypesConfig as rebuildFieldsConfig } from '@databases/fields';
import { container } from '@databases/service-container';

import { registerBridgeDataValtioWatch } from './bridge-identity/register-bridge-data-valtio-watch';

/**
 * Register core event listeners. This should be invoked early on in the bootstrapping of the application.
 * Returns a teardown that removes bus listeners and the bridge data Valtio watch.
 */
function registerCoreEventListeners(): VoidFunction {
  const eventBus = container.resolve('EventBus');
  const onFeatureFlagsChanged = rebuildFieldTypesConfig(rebuildFieldsConfig);

  eventBus.on('featureFlagsChanged', onFeatureFlagsChanged);

  const teardownBridgeDataWatch = registerBridgeDataValtioWatch();

  return () => {
    teardownBridgeDataWatch();

    eventBus.remove('featureFlagsChanged', onFeatureFlagsChanged);
  };
}

export { registerCoreEventListeners };
